<template>
  <div>
    <textarea
      v-if="isInEditingMode"
      :ref="`editableContent${this.uniqueKey}`"
      :rows="rows"
      @blur="handleLostFocus"
      v-model="content"
      @input="handleInput"
    ></textarea>
    <div v-else @click="handleContentClick" class="editable-content">
      {{
        content === null || content === ""
          ? "Click here and start typing..."
          : content
      }}
    </div>
  </div>
</template>

<style scoped>
textarea {
  resize: none;
  width: 100%;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-size: 16px;
}
textarea:focus {
  outline: none !important;
  border: 1px solid #00deab;
  box-shadow: 0 0 3px #00deab;
}
.editable-content {
  cursor: pointer;
}
</style>

<script>
export default {
  name: "EditableContent",
  data() {
    return {
      isInEditingMode: false,
      content: this.value,
    };
  },
  watch: {
    value() {
      this.content = this.value;
    },
  },
  methods: {
    handleContentClick() {
      this.isInEditingMode = true;
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    focusInput() {
      this.$refs[`editableContent${this.uniqueKey}`].focus();
    },
    handleLostFocus() {
      this.isInEditingMode = false;
      this.$emit("focusLost");
    },
    handleInput(e) {
      this.$emit("input", this.content);
    },
  },
  props: {
    value: String,
    uniqueKey: null,
    rows: {
      type: Number,
      default: 10,
    },
  },
};
</script>
